const colorTab = document.querySelectorAll('.variant-selectors .variant-block .variant-head p');

colorTab?.forEach(item => {
  const hideVariant = item.closest('.variant-block');
  if (item.textContent === 'Color new') {
    hideVariant.style.display = 'none';
  }
});

const outOfStockProduct = function () {
  const variantSelector = document.querySelectorAll(".variant-selectors")[0];
  const variantBlock = variantSelector.querySelectorAll(".variant-block")[1];
  const variantsList = variantBlock.querySelectorAll(".variants-option input");
  // console.log(variantsList);
};

const ProductForm = {
  product: null,
  form: null,
  variantOptions: null,
  addToCartButton: null,
  selectedVariant: null,
  buyButton: null,
  variantsData: null,
  sku: null,
  price: null,
  compare_price: null,
  discount: null,
  initForm(productElement) {
    this.product = productElement;
    this.form = productElement.querySelector(".product-form");
    this.variantOptions = productElement.querySelectorAll(".variants-option input");
    this.addToCartButton = productElement.querySelectorAll(".product-actions .ajax-cart");
    this.variantsData = JSON.parse(
      this.form.querySelector("script[type='application/ld+json']").innerHTML
    );
    this.registerUiComp();
    Array.from(this.variantOptions).forEach((el) => {
      el.addEventListener("change", this.updateVariant.bind(this));
    });
    this.variantsLoad();
    this.disableProductVariant();
  },
  variantsLoad() {
    let selectedVariantId = window.location.search.includes("?variant=")
      ? window.location.search.match(/variant=\d+/)[0].match(/\d+/)[0]
      : "";
    this.selectedVariant = this.variantsData.variants.find(
      (variant) => variant.id == selectedVariantId
    ) || this.variantsData.variants.find((variant) => variant.available == true);

    // console.log(selectedVariantId, this.selectedVariant);

    if (this.selectedVariant == undefined) {
      // console.log("null");
      outOfStockProduct();
    } else {
      const selectedVariantForSticky = this.selectedVariant.option1;
      const selectedStickyTrue = document.querySelector(".variants-option option[selected='true']");
      selectedStickyTrue?.removeAttribute("selected");

      const afterClickSelected = document.querySelector(`.variants-option option[data-value="${selectedVariantForSticky}"]`);
      afterClickSelected?.setAttribute("selected", "true");

      const stickyForm = document.querySelector(".sticky-cart-form")?.closest("form");
      if (stickyForm) {
        stickyForm.querySelector("input[name='id']").value = this.selectedVariant.id;
        const submitButton = stickyForm.querySelector("input[type='submit']");
        if (this.selectedVariant.available) {
          submitButton?.removeAttribute("disabled");
        } else {
          submitButton?.setAttribute("disabled", "true");
        }
      }

      if (this.selectedVariant.available && this.addToCartButton?.[0]) {
        this.addToCartButton[0].removeAttribute("disabled");
      } else {
        this.addToCartButton?.[0]?.setAttribute("disabled", "true");
      }

      this.updateUi();
      this.form.querySelector("input[name='id']").value = this.selectedVariant.id;
    }
  },
  updateVariant() {
    let selectedOptions = Array.from(this.variantOptions)
      .filter((el) => el.checked)
      .map((el) => el.value);

    // console.log("option selected ", selectedOptions);

    let selectedVariantData = this.variantsData.variants.filter((el) =>
      el.options.length === selectedOptions.length &&
      el.options.every((opt) => selectedOptions.indexOf(opt) !== -1)
    );

    // console.log("variant selected ", selectedVariantData);

    if (selectedVariantData.length > 0) {
      let searchQuery = `?variant=${selectedVariantData[0].id}`;
      window.history.pushState({}, "", searchQuery);
      this.selectedVariant = selectedVariantData[0];
      this.variantsLoad();
    }
  },
  updateUi() {
    if (this.sku) this.sku.innerHTML = this.selectedVariant.sku;
    if (this.price) {
      this.price.innerHTML = this.priceFormatter(
        Number(this.selectedVariant.price) / 100
      );
    }
    if (this.compare_price) {
      this.compare_price.innerHTML = this.priceFormatter(
        Number(this.selectedVariant.compare_at_price) / 100
      );
    }

    let discountVal = Number(this.selectedVariant.compare_at_price) > Number(this.selectedVariant.price)
      ? ((Number(this.selectedVariant.compare_at_price) - Number(this.selectedVariant.price)) / Number(this.selectedVariant.compare_at_price)) * 100
      : "";

    if (this.discount && discountVal) {
      this.discount.innerText = this.discount.innerText.replace(/\d+/, discountVal.toFixed());
    }
  },
  registerUiComp() {
    this.sku = this.product.querySelector(".product-sku");
    this.compare_price = this.product.querySelector(".compare-price s");
    this.price = this.product.querySelector(".sale-price");
    this.discount = this.product.querySelector(".product-discount p");
  },
  priceFormatter(amount) {
    let formatter = new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: Shopify.currency.active,
    });
    return formatter.format(amount);
  },
  disableProductVariant() {
    let allVariantsData = this.variantsData.variants;
    // console.log(allVariantsData, "data here");

    allVariantsData.forEach((el) => {
      if (!el.available) {
        let elementToDisable = document.querySelector(`.variants-option input[value="${el.option1}"]`);
        if (!elementToDisable) return;
        let elementToDisableId = elementToDisable.getAttribute("id");
        let elementToDisableIdLabel = document.querySelector(`.variants-option label[for="${elementToDisableId}"]`);
        let stickyDisable = document.querySelector(`.variants-option option[data-value="${el.option1}"]`);

        elementToDisable.setAttribute("disabled", "true");
        elementToDisableIdLabel?.classList.add("disableTrue");
        stickyDisable?.setAttribute("disabled", "disabled");
      }
    });
  }
};

const productElement = document.querySelector(".product-container");
productElement ? ProductForm.initForm(productElement) : "";
